// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","route-loading":"App_route-loading__jzXV1","version-select":"App_version-select__CDFqu","full-credits-button":"App_full-credits-button__KrYPH"};